import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from '@angular/core';
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../../shared/dialogs/confirmation/confirmation-dialog.component';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { MatDialog } from '@angular/material/dialog';
import { Role } from '../../../shared/models/role.model';
import { RoleDetailsDialog } from '../../../shared/dialogs/role-details/role-details.dialog';
import { RoleService } from '../../../shared/services/role.service';

@Component({
    selector: 'app-folder-permissions',
    standalone: false,
    templateUrl: './folder-permissions.component.html',
    styleUrl: './folder-permissions.component.scss'
})
export class FolderPermissionsComponent implements OnInit {

    @Input() roles: Role[];
    @Input() membersInRoles: Array<any>;
    @Input() title: string = 'NA';

    @Output() changeTabIndex: EventEmitter<any> = new EventEmitter<any>();
    

    // Constructor.
    public constructor(public dialog: MatDialog,
        private currentSiteService: CurrentSiteService,
        private roleService: RoleService) {
    }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    public get FolderLevelRoles(): Role[] {
        return this.roles?.filter(x => { return !x.isSiteLevel });
    }

    public get MembersInRoles(): Array<any> {
        return this.membersInRoles;
    }

    public openEditRoleDialog(data: any): void {
        const dialogRef = this.dialog.open(RoleDetailsDialog, {
            data: {
                role: data.role
            },
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(role => {
            if (role != null) {
                this.doUpdateRole(role);
            }
        });
    }

    public openCreateRoleDialog() {
        const dialogRef = this.dialog.open(RoleDetailsDialog, { data: { showSiteLevelRoleWarning: false, defaultToFolderlevel: true } });
        dialogRef.afterClosed().subscribe(newRole => {
            if (newRole != null) {
                newRole.name = newRole.name.trim();
                if (this.FolderLevelRoles.filter(r => r.name == newRole.name).length > 0) {
                    return;
                }
                newRole.dataCollectionId = this.currentSiteService.Site.id;
                this.roleService.create(newRole).then(res => {
                    this.roles.push(res);
                    this.currentSiteService.addRole(res as Role);
                });
            }
        });
    }

    public OpenFRMtab() {
        this.changeTabIndex.emit();
    }

    // Helper methods.
    private doUpdateRole(role: any) {
        this.roleService.update(role).then(res => {
            let roles = this.roles?.filter(x => x.id != res.id);
            this.currentSiteService.updateRole(role);
        });
    }

    public deleteRole(event: any, role: any): void {
        this.deleteOnConfirm(role, () => {
            this.roleService.delete(role.id).then(res => {
                this.roles = this.roles?.filter(r => r.id != role.id);
                this.currentSiteService.deleteRole(role);
            });
        });
    }

    private deleteOnConfirm(role: Role, callback: Function) {
        if (role.memberCount() > 0) {
            alert("You cannot delete a Role that has members. Remove the members from this role first, then delete it.");
            return;
        }
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmationDialogModel(`Delete Role`, `Are you sure you want to delete ${role.name} Role? The operation cannot be undone.`)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) callback();
        });
    }

}
